import React from 'react';
import usePersonalRoomListState from './PersonalRoomList.state';
import PersonalRoomListView from './PersonalRoomList.view';

const PersonalRoomList: React.FC = () => {
    const state = usePersonalRoomListState();
    return <PersonalRoomListView {...state} />;
};
export default PersonalRoomList;
